import React from 'react';
import './index.css'

export const ServerPageDecoration = ({children, paddingTop = 20, fullWidth = false, maxWidth = 661}) => {
    const outerWidth = fullWidth ? '100%' : `${maxWidth}px`;
    const innerWidth = fullWidth ? '100%' : `${maxWidth - 44}px`;
    return (
      <div style={{
        width: outerWidth,
        background: '#f0f4fb',
        margin: '0 auto',
        padding: '8px',
        borderRadius: 12,
      }}
      >
        <div
        style={{
          backgroundColor: '#ffffff',
          width: innerWidth,
          margin: '0 auto',
          padding: `${paddingTop}px 18px 12px 18px`,
          borderRadius: 10,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}
        >
          { children }
        </div>
      </div>
  );
};

